import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import './PlayerDetails.css';

const PlayerDetails = () => {
  const { id } = useParams();
  const [player, setPlayer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPlayerDetails = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`/api/rankings/${id}`);
        setPlayer(res.data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching player details:', err);
        setError('Player not found or failed to load data');
        setLoading(false);
      }
    };

    fetchPlayerDetails();
  }, [id]);

  const getJobName = (jobId) => {
    const jobs = {
      0: 'Beginner',
      100: 'Warrior',
      110: 'Fighter',
      120: 'Page',
      130: 'Spearman',
      200: 'Magician',
      210: 'Wizard (Fire/Poison)',
      220: 'Wizard (Ice/Lightning)',
      230: 'Cleric',
      300: 'Bowman',
      310: 'Hunter',
      320: 'Crossbowman',
      400: 'Thief',
      410: 'Assassin',
      420: 'Bandit',
      500: 'Pirate',
      510: 'Brawler',
      520: 'Gunslinger'
    };
    
    return jobs[jobId] || 'Unknown';
  };

  if (loading) {
    return <div className="spinner"></div>;
  }

  if (error) {
    return (
      <div className="player-details-page">
        <div className="card error-card">
          <div className="card-body">
            <h2>Error</h2>
            <p>{error}</p>
            <Link to="/rankings" className="btn btn-primary">
              Back to Rankings
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="player-details-page">
      <div className="player-header">
        <Link to="/rankings" className="back-btn">
          &larr; Back to Rankings
        </Link>
      </div>

      <div className="player-card card">
        <div className="card-header">
          <h1>{player.name}</h1>
          <div className="player-title">
            Level {player.level} {getJobName(player.job)}
          </div>
        </div>

        <div className="player-info">
          <div className="info-section">
            <h3>Basic Info</h3>
            <div className="info-grid">
              <div className="info-item">
                <span className="info-label">Account</span>
                <span className="info-value">{player.accountName}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Fame</span>
                <span className="info-value">{player.fame}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Mesos</span>
                <span className="info-value">{player.meso?.toLocaleString() || 0}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Gender</span>
                <span className="info-value">{player.gender === 0 ? 'Male' : 'Female'}</span>
              </div>
            </div>
          </div>

          <div className="info-section">
            <h3>Stats</h3>
            <div className="stats-grid">
              <div className="stat-item">
                <div className="stat-value">{player.str}</div>
                <div className="stat-label">STR</div>
              </div>
              <div className="stat-item">
                <div className="stat-value">{player.dex}</div>
                <div className="stat-label">DEX</div>
              </div>
              <div className="stat-item">
                <div className="stat-value">{player.int}</div>
                <div className="stat-label">INT</div>
              </div>
              <div className="stat-item">
                <div className="stat-value">{player.luk}</div>
                <div className="stat-label">LUK</div>
              </div>
            </div>
          </div>

          <div className="info-section">
            <h3>Health & Mana</h3>
            <div className="bar-container">
              <div className="hp-bar">
                <div className="bar-label">HP</div>
                <div className="bar-wrapper">
                  <div 
                    className="bar-fill hp" 
                    style={{ width: `${(player.hp / player.maxhp) * 100}%` }}
                  ></div>
                  <div className="bar-text">
                    {player.hp} / {player.maxhp}
                  </div>
                </div>
              </div>
              <div className="mp-bar">
                <div className="bar-label">MP</div>
                <div className="bar-wrapper">
                  <div 
                    className="bar-fill mp" 
                    style={{ width: `${(player.mp / player.maxmp) * 100}%` }}
                  ></div>
                  <div className="bar-text">
                    {player.mp} / {player.maxmp}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlayerDetails;